<sim-edit-panel [icon]="icon()" [heading]="title()" (closePanel)="close()">
  @if (descriptionTemplate(); as descriptionTpl) {
    <div class="space-select__description">
      <ng-container [ngTemplateOutlet]="descriptionTpl" />
    </div>
  }

  <div class="space-select__box">
    <div class="space-select__field">
      <label class="space-select__label" i18n="@@ADD_ASSET_SPACE_LABEL">
        Space <span class="space-select__required">*</span>
      </label>
      <sim-select
        i18n-placeholder="@@ASSETS_SELECT_SPACE_PLACEHOLDER"
        placeholder="Select space..."
        [simSelectSearch]="spaces()"
        [searchWith]="spaceSearchText"
        #spaceSearch="simSelectSearch"
        [value]="selectedSpaceId()"
        (valueChange)="onSpaceChange($event)"
      >
        @for (space of spaceSearch.filtered(); track space.id) {
          <sim-option [value]="space.id">
            <span>{{ space.name }}</span>
          </sim-option>
        }
      </sim-select>
    </div>

    <div class="space-select__confirm">
      <button
        sim-flat-button
        simColor="primary"
        [disabled]="!selectedSpaceId()"
        (click)="confirm()"
        i18n="@@GENERAL_CONFIRM"
      >
        Confirm
      </button>
    </div>
  </div>

  <ng-container editPanelFooter>
    <button sim-stroked-button simColor="primary" type="button" (click)="cancel()" i18n="@@GENERAL_CANCEL">
      Cancel
    </button>
    <button sim-flat-button simColor="primary" type="button" [disabled]="true">
      <span>{{ addLabel() }}</span>
    </button>
  </ng-container>
</sim-edit-panel>
